import { parse } from 'query-string';
import { CASE_AMENDING_KPP_TOGGLES, jobNames } from './../helpers';
import {
  LOCATION_CHANGE,
  SELECT_PERFORMANCE_JOB,
  RESET_PERFORMANCE_PAGE
} from './../actions';

const initialState = {
  caseAmendingKppPerformanceInfo: {
    toggles: 15,
    buildFilter: '',
    snPartII: '',
    givenJob: '',
    dispatcherId: 0,
    jobName: jobNames.CASE_AMENDING_KPP
  },
  selectedJobs: []
};

const caseAmendingKppPerformancePage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_PERFORMANCE_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case RESET_PERFORMANCE_PAGE:
      return initialState;
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        action.payload.pathname !== '/case-amending-kpp-performance') {
        return state;
      }

      // These are for the main selector:
      // t: build type bit representation
      // f: build filter
      // i: selected casename
      // j: given job number, used to highlight a job coming from another page
      // d: id for selected dispatcher
      // The names need to be short because they're part of the URL query.
      const { f, i, t, j, d } = parse(action.payload.search);

      const parseCaseAmendingKppPerformanceInfo = (
        toggles,
        buildFilter,
        caseName,
        givenJob,
        dispatcher,
        metricInfo,
      ) => {
        const parsedToggles = parseInt(toggles);
        const parsedGivenJob = parseInt(j);
        const parsedDispatcher = parseInt(dispatcher);

        return {
          toggles: (parsedToggles < 0) || (parsedToggles > 15) || isNaN(parsedToggles) ?
            metricInfo.toggles :
            parsedToggles,
          buildFilter: buildFilter ? buildFilter : '',
          snPartII: caseName ? caseName : '',
          givenJob: (parsedGivenJob < 0) || isNaN(parsedGivenJob) ?
            metricInfo.givenJob :
            parsedGivenJob,
          dispatcherId: (parsedDispatcher < 0) || isNaN(parsedDispatcher) ?
            0 :
            parsedDispatcher,
          jobName: metricInfo.jobName
        };
      };

      const parsedInfo =
        parseCaseAmendingKppPerformanceInfo(
          t, f, i, j, d, state.caseAmendingKppPerformanceInfo);
      return {
        ...state,
        caseAmendingKppPerformanceInfo: parsedInfo,
        selectedJobs: parsedInfo.givenJob ?
          [{ value: `${parsedInfo.givenJob}` }] :
          []
      };

    default:
      return state;
  }
};

export default caseAmendingKppPerformancePage;

const getCaseAmendingKppPerformancePage = state => state.caseAmendingKppPerformancePage;
export const getCaseAmendingKppPerformanceInfo = state =>
  getCaseAmendingKppPerformancePage(state).caseAmendingKppPerformanceInfo ||
   initialState.caseAmendingKppPerformanceInfo;
export const getCaseAmendingKppPerformanceOutliersShown = state =>
  getCaseAmendingKppPerformancePage(state).toggles & CASE_AMENDING_KPP_TOGGLES.OUTLIER;
export const getCaseAmendingKppPerformanceSelectedJobs = state =>
  getCaseAmendingKppPerformancePage(state).selectedJobs;



// WEBPACK FOOTER //
// src/reducers/caseAmendingKppPerformancePage.js